import { styled } from '@mui/system'

export const RiskLevelWrapper = styled('div')`
    flex: 1;
    min-width: 0;
`

export const CategoryBarContainer = styled('div')`
    margin-top: 24px;
`
